import * as constants from './constants';

export const initialState = {
  loading: true,
  data: [],
  error: null,
};

export const suggestedItemsReducer = (state = initialState, action) => {
  switch (action.type) {
  case constants.GET_SUGGESTED_ITEMS_SUCCESS: {
    const names = [];
    const duplicates = [];

    return {
      ...state,
      loading: false,
      data: action.payload.filter((item) => {
        // prevent saving duplicate (by name) items
        if(!names.includes(item.name)) {
          names.push(item.name);
          return true;
        }
        duplicates.push(item.name);

        return false;
      }).map((item) => ({
        ...item,
        type: duplicates.includes(item.name) ? 'query' : item.type,
      })),
    };
  }
  case constants.GET_SUGGESTED_ITEMS_ERROR:
    return { ...state, loading: false, error: action.payload };
  case constants.RESET_SUGGESTED_ITEMS:
    return initialState;
  default:
    return state;
  }
};
